export const LIGHT_BLUE = "#9FECFC"
export const LIGHT_GREEN = "#C8FC87"
export const YELLOW = "#FBFC86"
export const ORANGE = "#FDDF90"
export const PINK = "#FDC4E7"
export const LIGHT_PURPLE = "#E0BDFA"
export const RED = "#F62A5C"
export const BLACK = "#000000"
export const LIGHT_GRAY = "#f4f4f6"
export const WHITE = "#ffffff"
export const TRANSPARENT = "#ffffff00"
export const DEFAULT_NOTE_COLOR = YELLOW

export const NOTE_COLORS = [
    { name: "light-blue", color: LIGHT_BLUE },
    { name: "light-green", color: LIGHT_GREEN },
    { name: "yellow", color: YELLOW },
    { name: "orange", color: ORANGE },
    { name: "pink", color: PINK },
    { name: "light-purple", color: LIGHT_PURPLE },
    { name: "red", color: RED },
    { name: "black", color: BLACK },
    { name: "light-gray", color: LIGHT_GRAY },
    { name: "white", color: WHITE },
    { name: "transparent", color: TRANSPARENT },
]
